import { SelectButton } from 'primereact/selectbutton'
import React, { useState ,useEffect, useRef} from 'react'
import './index.scss'
import { useTranslation } from 'react-i18next'
import { ToggleButton } from 'primereact/togglebutton'
import { Dropdown } from '../../../common/DropDown'
//import { pushEventBookingDashboard} from '../../utils/analytics'
import downArrow from '../../../assets/images/chevronDown.svg'
import upArrow from '../../../assets/images/chevronUp.svg'
import { updateBooking } from '../../../services/quoteServices'

const ChartFilter = ({
	period,
	setPeriod,
	chartDataType,
	setChartDataType,
	lastUpdatedDate,
	currency,
	chartData,
	setChangeToLocalCurrency,
	setLocalCur,
	changeToLocalCurrency,
	pushEventBookingDashboard,
	pushEventBookingTime

}) => {
	const { t, i18n } = useTranslation(['labels'])

	//const [buttonTitle, setButtonTitle] = useState(null)
	const [showToggleButton, setShowToggleButton] = useState(false)
	const [currencyOptions, setCurrencyOptions] = useState([])
	const [activeCur, setActiveCur] = useState();
	const [open, setOpen] = useState(false);
	const [currencyOpen, setCurrencyOpen] = useState(false);
	const PERIOD_SELECT_ITEMS = [
		{ label: t('DASHBOARD.MONTH'), value: 'MONTHLY' },
		{ label: t('DASHBOARD.YEAR'), value: 'YEARLY' },
	]

	const handleRadio = (e) => {
		setChartDataType(e.target.value)
		pushEventBookingDashboard(e.target.value)
		  setOpen(false);
		
	}
	//console.log(chartDataType,"chartDataType")

	const handleToggle = (val) => {
		val === 'USD'
			? setChangeToLocalCurrency(false)
			: setChangeToLocalCurrency(true)
		//setButtonTitle(chartData.currencyCode)
	}

	useEffect(() => {
		setActiveCur(currency)
	}, [currency])

	useEffect(() => {
		let CURRENCIES = []
		if (
			chartData &&
			chartData.currencyCode &&
			chartData.currencyCode !== 'USD'
		) {
			setShowToggleButton(true)
			CURRENCIES.push({
				label: chartData.currencyCode,
				value: chartData.currencyCode,
			})
		}
		CURRENCIES.push({ label: 'USD', value: 'USD' })
		setCurrencyOptions(CURRENCIES)
	}, [chartData])

			const selectedLabel = {
				awbCount: t('DASHBOARD.AWB_CNT'),
				tonnage: t('DASHBOARD.TONNAGE'),
				charges: t('DASHBOARD.TTL_COST')
			}[chartDataType];
	const dropdownRef = useRef(null);
	const currencyDropdownRef = useRef(null);
	useEffect(() => {
	if (!open && !currencyOpen) return; 

	const handleClickOutside = (event) => {
		// Close radio dropdown
		if (open && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
			setOpen(false);
		}

		// Close currency dropdown
		if (currencyOpen && currencyDropdownRef.current && !currencyDropdownRef.current.contains(event.target)) {
			setCurrencyOpen(false);
		}
	};

	document.addEventListener("mousedown", handleClickOutside);
	return () => document.removeEventListener("mousedown", handleClickOutside);
}, [open, currencyOpen]);



	return (
		<div className='d-flex  chart-filter-header-div-container'>
		<div className='chart-filter-component'>
			{/* <div className='row'> */}
			{/* <div className='col-12'> */}
			{/* <div className='d-flex flex-column flex-lg-row align-items-lg-center chart-filter-component'> */}
			<div className='period-toggle-wrapper'>
				<SelectButton
					// className='shipping-type custom-select-button'
					value={period}
					className="common-select-button"
					options={PERIOD_SELECT_ITEMS}
					onChange={(e) => {
						if (e.value) {
							setPeriod(e.value)
						}
						pushEventBookingTime(e.value)
					} }
				></SelectButton>
			</div>
			<div className="radio-dropdown-container" ref={dropdownRef}>
				<button className={`dropdown-toggle ${open ? 'dropdown-open' : ''}`} onClick={() => setOpen(!open)}>
					{selectedLabel}
					<span className="arrow">
						<img
							src={open ? upArrow : downArrow}
							alt="arrow" />
					</span>
				</button>

				{open && (
					<div className="dropdown-radio">
						<div
							className={`dropdown-radio-option ${chartDataType === 'awbCount' ? 'radio-selected' : ''}`}
							  onClick={() => handleRadio({ target: { value: 'awbCount' } })}
						>
							<label className="custom-radio-label mb-0" htmlFor="awbCount">
								{t('DASHBOARD.AWB_CNT')}
								<input
									id="awbCount"
									type="radio"
									value="awbCount"
									name="chart-type"
									onChange={handleRadio}
									aria-describedby='awb-count'
									checked={chartDataType === 'awbCount' ? true : false} />
							</label>
							<span className="custom-radio-icon" onClick={() => handleRadio({ target: { value: 'awbCount' } })}></span>
						</div>



						<div className={`dropdown-radio-option ${chartDataType === 'tonnage' ? 'radio-selected' : ''}`}
						 onClick={() => handleRadio({ target: { value: 'tonnage' } })}
						 >
							<label className='custom-radio-label mb-0' htmlFor='tonnage'>
								{t('DASHBOARD.TONNAGE')}
								<input
									id='tonnage'
									type='radio'
									value='tonnage'
									name='chart-type'
									// className='form-item__field'
									aria-describedby='tonnage'
									onChange={handleRadio}
									checked={chartDataType === 'tonnage' ? true : false} />

							</label>
							<span className="custom-radio-icon" onClick={() => handleRadio({ target: { value: 'tonnage' } })}></span>
						</div>

						<div className={`dropdown-radio-option ${chartDataType === 'charges' ? 'radio-selected' : ''}`}
						 onClick={() => handleRadio({ target: { value: 'charges' } })}
						 >
							<label htmlFor='charges' className='custom-radio-label mb-0'>
								{t('DASHBOARD.TOTAL_COST_DUE_CARRIER')}
								<input
									id='charges'
									type='radio'
									value='charges'
									name='chart-type'
									// className='form-item__field'
									aria-describedby='charges'
									onChange={handleRadio}
									checked={chartDataType === 'charges' ? true : false} />

							</label>
							<span className="custom-radio-icon" onClick={() => handleRadio({ target: { value: 'charges' } })}></span>
						</div>
					</div>
				)}
			</div>
			{chartDataType === "charges" && showToggleButton && (
				<div
				className="radio-dropdown-container"
				onClick={(e) => e.stopPropagation()} 
				ref={currencyDropdownRef}
				>
				<button
				type="button"
				className={`dropdown-toggle ${currencyOpen ? "dropdown-open" : ""}`}
				onClick={(e) => {
				e.stopPropagation(); 
				setCurrencyOpen((prev) => !prev);
				}}
				>
				{activeCur}
				<span className="arrow">
				<img src={currencyOpen ? upArrow : downArrow} alt="arrow" />
				</span>
				</button>

				{currencyOpen && (
				<div
				className="dropdown-radio-currency"
				onClick={(e) => e.stopPropagation()} 
				>
				{currencyOptions.map((opt) => {
					const value = opt.value || opt; 
					const label = opt.label || opt;

					return (
					<div
					key={value}
					className={`dropdown-radio-option ${
					activeCur === value ? "radio-selected" : ""
					}`}
					onClick={() => {
					handleToggle(value);
					setActiveCur(value);
					setLocalCur(value);
					setCurrencyOpen(false); 
					}}
					>
					<label className="custom-radio-label mb-0">{label}</label>
					</div>
					);
				})}
				</div>
				)}
				</div>
				)}


			{/* {chartDataType === 'charges' && showToggleButton && (
				<div className='d-flex flex-column flex-lg-row align-items-lg-center currency-selector'>
					<Dropdown
						className='cust-dropdown'
						options={currencyOptions}
						value={activeCur}
						onChange={(e) => {
							handleToggle(e.target.value)
							setActiveCur(e.target.value)
							setLocalCur(e.target.value)
						} }
					></Dropdown>
				</div>


			)} */}




			{/* <div className=''>
        <div className='h-100 d-flex flex-column flex-lg-row align-items-lg-center'>
            <div className='custom-pl-3 chart-filter-row'>
                <div className='form-item form-item--radio'>
                    <input
                        id='awbCount'
                        type='radio'
                        value='awbCount'
                        name='chart-type'
                        className='form-item__field'
                        aria-describedby='awb-count'
                        onChange={handleRadio}
                        checked={chartDataType === 'awbCount' ? true : false}
                    />
                    <label htmlFor='awbCount' className='form-item__label'>
                        {t('DASHBOARD.AWB_CNT')}
                    </label>
                </div>
            </div>
            <div className='custom-pl-3 chart-filter-row'>
                <div className='form-item form-item--radio'>
                    <input
                        id='tonnage'
                        type='radio'
                        value='tonnage'
                        name='chart-type'
                        className='form-item__field'
                        aria-describedby='tonnage'
                        onChange={handleRadio}
                        checked={chartDataType === 'tonnage' ? true : false}
                    />
                    <label htmlFor='tonnage' className='form-item__label'>
                        {t('DASHBOARD.TONNAGE')}
                    </label>
                </div>
            </div>
            <div className='custom-pl-3 chart-filter-row'>
                <div className='d-flex align-items-center'>
                    <div className='cost_selector form-item form-item--radio'>
                        <input
                            id='charges'
                            type='radio'
                            value='charges'
                            name='chart-type'
                            className='form-item__field'
                            aria-describedby='charges'
                            onChange={handleRadio}
                            checked={chartDataType === 'charges' ? true : false}
                        />
                        <label htmlFor='charges' className='form-item__label'>
                            {t('DASHBOARD.TOTAL_COST_DUE_CARRIER')}
                        </label>
                    </div>
                    {chartDataType === 'charges' && showToggleButton && (
                        <div className='d-flex flex-column flex-lg-row align-items-lg-center currency-selector'>
                            <Dropdown
                                className='cust-dropdown'
                                options={currencyOptions}
                                value={activeCur}
                                onChange={(e) => {
                                    handleToggle(e.target.value)
                                    setActiveCur(e.target.value)
                                    setLocalCur(e.target.value)
                                }}
                            ></Dropdown>
                        </div>
                        

                    )}
                </div>
            </div>
        </div>
    </div> */}
			{/* <div className='custom-pl-3 updated-time_wrap text-lg-right'>
        <div className='updated-time'>
            {t('DASHBOARD.LUD')} : {lastUpdatedDate}
        </div>
    </div> */}
			{/* </div> */}
			{/* </div> */}
			{/* </div> */}
		</div>
		<div className='updated-time'>
				{t('DASHBOARD.LUD')} : {lastUpdatedDate}
			</div>
		</div>
	)
}

export default ChartFilter
